var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "must-have-exactly-one-root-element" },
    [
      _c("menu-album", { attrs: { profil: _vm.profil } }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "albumMainBody" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "sideMenu__close",
              on: {
                click: function($event) {
                  return _vm.$router.push({ name: "profil" })
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "albumList__separator" }),
          _vm._v(" "),
          _c("div", { staticClass: "albumListing__wrap" }, [
            _c("div", { staticClass: "albumList__half --first" }, [
              _c(
                "div",
                {
                  staticClass:
                    "albumList__heading mb-3 d-flex align-items-center justify-content-between"
                },
                [
                  _c("h2", { staticClass: "mb-0" }, [
                    _vm._v("Mliečne recepty "),
                    _c("span", {
                      staticClass: "icon --questionMark",
                      on: {
                        click: function($event) {
                          return _vm.$bvModal.show("modalAlbumAnatomia")
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "mb-0" }, [
                    _vm._v("Máš "),
                    _c("span", { staticClass: "--bold" }, [
                      _vm._v(_vm._s(_vm.countOwned))
                    ]),
                    _vm._v(" z celkových "),
                    _c("span", { staticClass: "--bold" }, [
                      _vm._v(_vm._s(_vm.countTotal) + " receptov")
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _vm.album.recepty
                ? _c(
                    "div",
                    { staticClass: "albumListing__list --recepty" },
                    _vm._l(_vm.album.recepty, function(recept, index) {
                      return index >= _vm.startIndex &&
                        index <= _vm.endIndex - 9
                        ? _c(
                            "div",
                            {
                              class:
                                "albumListing__item" +
                                [
                                  recept.current == recept.album_recepty_max
                                    ? " --done"
                                    : ""
                                ],
                              on: {
                                click: function($event) {
                                  return _vm.checkItem(recept, index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "albumListing__imageWrap" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      src:
                                        "assets/img/album/recepty/" +
                                        recept.album_recepty_img_a,
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "albumListing__descriptionWrap"
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "albumListing__name mb-0" },
                                    [
                                      _vm._v(
                                        _vm._s(recept.album_recepty_nadpis)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "albumListing__progress" },
                                    _vm._l(recept.album_recepty_max, function(
                                      bar,
                                      rindex
                                    ) {
                                      return _c("span", [
                                        recept.current >= rindex + 1
                                          ? _c("span", {
                                              staticClass:
                                                "albumListing__bar --full"
                                            })
                                          : _c("span", {
                                              staticClass: "albumListing__bar"
                                            })
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              recept.current == recept.album_recepty_max
                                ? _c("span", {
                                    staticClass: "albumListing__checkmark"
                                  })
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                : _vm._e()
            ]),
            _vm._v(" "),
            _vm.album.recepty
              ? _c("div", { staticClass: "albumList__half --second" }, [
                  _c(
                    "div",
                    { staticClass: "albumListing__list --recepty" },
                    _vm._l(_vm.album.recepty, function(recept, index) {
                      return index >= _vm.startIndex + 9 &&
                        index <= _vm.endIndex
                        ? _c(
                            "div",
                            {
                              class:
                                "albumListing__item" +
                                [
                                  recept.current == recept.album_recepty_max
                                    ? " --done"
                                    : ""
                                ],
                              on: {
                                click: function($event) {
                                  return _vm.checkItem(recept, index)
                                }
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "albumListing__imageWrap" },
                                [
                                  _c("img", {
                                    staticClass: "img-fluid",
                                    attrs: {
                                      src:
                                        "assets/img/album/recepty/" +
                                        recept.album_recepty_img_a,
                                      alt: ""
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "albumListing__descriptionWrap"
                                },
                                [
                                  _c(
                                    "p",
                                    { staticClass: "albumListing__name mb-0" },
                                    [
                                      _vm._v(
                                        _vm._s(recept.album_recepty_nadpis)
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "albumListing__progress" },
                                    _vm._l(recept.album_recepty_max, function(
                                      bar,
                                      rindex
                                    ) {
                                      return _c("span", [
                                        recept.current >= rindex + 1
                                          ? _c("span", {
                                              staticClass:
                                                "albumListing__bar --full"
                                            })
                                          : _c("span", {
                                              staticClass: "albumListing__bar"
                                            })
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              recept.current == recept.album_recepty_max
                                ? _c("span", {
                                    staticClass: "albumListing__checkmark"
                                  })
                                : _vm._e()
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _vm.prevPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --prev",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage - 1)
                    }
                  }
                },
                [
                  _c("span", { staticClass: "icon --prev" }),
                  _vm._v("Predchádzajúca strana\n            ")
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.nextPage != 0
            ? _c(
                "div",
                {
                  staticClass: "albumListing__nav --next",
                  on: {
                    click: function($event) {
                      return _vm.changePage(_vm.currentPage + 1)
                    }
                  }
                },
                [
                  _vm._v("\n                Ďalšia strana"),
                  _c("span", { staticClass: "icon --next" })
                ]
              )
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modalAlbumAnatomia",
          staticClass: "modal fade",
          attrs: {
            id: "modalAlbumAnatomia",
            "hide-footer": "",
            "hide-header": "",
            centered: "",
            tabindex: "-1",
            role: "dialog",
            "aria-labelledby": "modalAlbumAnatomiaTitle",
            "aria-hidden": "true"
          }
        },
        [
          _c(
            "b-button",
            {
              staticClass: "m-modalInfo__close",
              attrs: { block: "" },
              on: {
                click: function($event) {
                  return _vm.$bvModal.hide("modalAlbumAnatomia")
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body", staticStyle: { padding: "0" } },
            [
              _c("div", { staticClass: "text-center" }, [
                _c("h2", { staticClass: "text-center" }, [_vm._v("Nápoveda")]),
                _vm._v(" "),
                _c("p", { staticClass: "text-18" }, [
                  _vm._v(
                    "Fajnoty s použitím mliečnch výrobkov si môžeš pripraviť rýchlo a ľahko. Inšpiruj sa napríklad aj týmito receptami. Do tejto kuchárskej knihy ich dostaneš za točenie kolesom šťastia, alebo za dosiahnuté úspechy v tvojej hre."
                  )
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "albumPages" }, [
      _c("div", { staticClass: "albumPage --first" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --second" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --third" }),
      _vm._v(" "),
      _c("div", { staticClass: "albumPage --fourth" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }